/*
  Arrow controls for the Instagram rail.

  The rail itself is a CSS scroll-snap container, so it already works by swipe
  and keyboard with no JavaScript. This only adds the desktop arrows and keeps
  them disabled at each end.
*/
class InstagramSlider extends HTMLElement {
  connectedCallback() {
    this.rail = this.querySelector('[data-ig-rail]');
    this.prev = this.querySelector('[data-ig-prev]');
    this.next = this.querySelector('[data-ig-next]');
    if (!this.rail) return;

    this.update = this.update.bind(this);

    if (this.prev) this.prev.addEventListener('click', () => this.scrollByPage(-1));
    if (this.next) this.next.addEventListener('click', () => this.scrollByPage(1));

    this.rail.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);

    this.update();
  }

  disconnectedCallback() {
    if (this.rail) this.rail.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.update);
  }

  scrollByPage(direction) {
    const first = this.rail.querySelector('.ig__item');
    if (!first) return;

    const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
    const step = first.getBoundingClientRect().width + gap;
    this.rail.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  update() {
    const maxScroll = this.rail.scrollWidth - this.rail.clientWidth;
    // A pixel of slack: sub-pixel widths mean scrollLeft rarely hits the end exactly.
    const atStart = this.rail.scrollLeft <= 1;
    const atEnd = this.rail.scrollLeft >= maxScroll - 1;

    if (this.prev) this.prev.toggleAttribute('disabled', atStart);
    if (this.next) this.next.toggleAttribute('disabled', atEnd || maxScroll <= 0);
  }
}

if (!customElements.get('instagram-slider')) {
  customElements.define('instagram-slider', InstagramSlider);
}
